import { render } from "./navbar-en.vue?vue&type=template&id=56d29efa&scoped=true"
import script from "./navbar-en.vue?vue&type=script&lang=js"
export * from "./navbar-en.vue?vue&type=script&lang=js"

import "./navbar-en.vue?vue&type=style&index=0&id=56d29efa&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d29efa"]])

export default __exports__